import { defineField, defineType } from 'sanity'

import getPageInfo, { seoGroup } from '../../objects/pageInfo'

export default defineType({
  title: 'Coming Soon',
  name: 'comingSoon',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    {
      name: 'old_content',
      title: 'Old content',
    },
    seoGroup,
  ],
  fields: [
    defineField({
      name: 'phases',
      title: 'Phases',
      type: 'array',
      of: [{ type: 'specialEventPhase' }],
      validation: (rule) => [rule.min(1), rule.max(4)],
      group: 'content',
    }),
    defineField({
      title: 'Before Countdown Content',
      name: 'beforeCountdown',
      type: 'beforeCountdown',
      group: 'old_content',
    }),
    defineField({
      title: 'After Countdown Content',
      name: 'afterCountdown',
      type: 'afterCountdown',
      group: 'old_content',
    }),
    getPageInfo({ lockCanonical: true }),
  ],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare(selection) {
      const { title = 'New Page', description: subtitle = '' } =
        selection.pageInfo || {}
      return {
        title,
        subtitle,
      }
    },
  },
})
